var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { Subject } from '@/models/Subject';
import { Student } from '@/models/Student';
import { UserSubject as UserSubjectModel, UserSubjectStatusEnum } from '@/models/UserSubject';
import BulkUpdateStatusFinishedRatingDialog from '@/components/dialog/BulkUpdateStatusFinishedRatingDialog/BulkUpdateStatusFinishedRatingDialog';
import UserSubjectMessageForm from '@/components/user-subject-message-form/UserSubjectMessageForm';
import BulkUpdateDescriptionDialog from '@/components/dialog/BulkUpdateDescriptionDialog/BulkUpdateDescriptionDialog';
import TreatmentDialog from '@/views/Curricula/TreatmentDialog';
import LoadFailed from '@/views/Errors/LoadFailed';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { UserSubjectSummary } from '@/models/UserSubjectSummary';
import AlertCard from '@/components/alert-card/AlertCard';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { excludeRoles } from '@/support/ExcludeRoles';
import ErrorHandler from '@/support/ErrorHandler';
import StatusCard from '@/components/status-card/StatusCard';
import EditSubjectDialog from '@/components/curriculum/EditSubjectDialog';
import DescriptionColumn from '@/components/DescriptionColumn/DescriptionColumn.vue';
import SubjectDialog from '@/components/SubjectDialog/SubjectDialog.vue';
import ScoolSnackbar from '@/components/ScoolSnackbar/ScoolSnackbar';
import { Group } from '@/models/Group';
import DownloadOverviewDialog from '@/components/DownloadOverviewDialog/DownloadOverviewDialog';
import ProgressDialog from '@/components/ProgressDialog/ProgressDialog.vue';
import { groupBy, sortBy, debounce, omitBy } from 'lodash';
// New components
import SubjectGoalIcons from './components/SubjectGoalIcons/SubjectGoalIcons.vue';
import SubjectUser from './components/SubjectUser/SubjectUser.vue';
import UserSubject from './components/UserSubject/UserSubject.vue';
import SubjectHeader from './components/SubjectHeader/SubjectHeader.vue';
import { uniq } from 'lodash';
import SubjectGroupSelect from './components/SubjectGroupSelect/SubjectGroupSelect';
import { RolesEnum } from '@/items/Roles';
import GroupNotesDialog from '@/components/GroupNotesDialog/GroupNotesDialog';
let SubjectOverviewNew = class SubjectOverviewNew extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.$pageTitle = 'Schedule Subject';
        this.isLoading = false;
        this.initialState = true;
        this.userSubjectSummary = null;
        this.RolesEnum = RolesEnum;
        this.isGroupNotesDialogOpen = false;
        this.statusColorMap = {
            highlighted: '#f8c623',
            busy: '#008ac4',
            old: '#ff7800',
            inactive: '#9b9b9b',
            closed: '#d0021b',
            finished: '#00b900',
        };
        // protected filters: SummaryFilters = {
        //   topic: '96c49334-65b5-46c8-b3f1-4699fd284b1a',
        //   statuses: [
        //     UserSubjectStatusEnum.BUSY,
        //     UserSubjectStatusEnum.HIGHLIGHTED,
        //     UserSubjectStatusEnum.OLD,
        //     UserSubjectStatusEnum.FINISHED,
        //     UserSubjectStatusEnum.CLOSED,
        //   ],
        //   levels: ['8164f012-d5bd-4971-b2a4-3d426bb0792a'],
        // }
        this.subjects = [];
        this.students = [];
        this.hasUserSubjects = false;
        this.userSubjectGrid = null;
        this.subjectStatusTotals = {};
        this.selectedStudentId = '';
        this.isEditingTreatment = false;
        this.subjectDialogSubject = null;
        this.isSubjectDialogOpen = false;
        this.isShowingEditSubjectDialog = false;
        this.isDisplayingProgressDialog = false; // #FIXME, NEVER USED TO DO SOMETHING?
        this.isDisplayingBulkUpdateDescriptionDialog = false;
        this.isDisplayingIdpNotesDialog = false;
        this.isDisplayingBulkUpdateStatusFinishedRatingDialog = false;
        this.preselectedGroup = null;
        this.selectedStatus = '';
        this.debounceFetchUserSubjects = debounce(this.fetchUserSubjects, 100);
        this.fetchUserSubjectsPromiseRejector = null;
        this.fetchUserSubjectsTimeout = null;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.onMounted();
    }
    async onMounted() {
        await this.fetchUserSubjects();
        // 1 Group has been preselected => fetch that group and print name
        if (this.filters && this.filters.groups && this.filters.groups.length === 1) {
            this.preselectedGroup = await new Group().find(this.filters.groups[0]);
        }
    }
    // #endregion
    // #region Event handlers
    async onBarDirectionClick(direction) {
        const scrollableContainer = document.querySelector('.subject-overview__table-container');
        if (!scrollableContainer) {
            return;
        }
        this.sideScrollSummaryTable(scrollableContainer, direction);
    }
    async onBulkProgressChanged(progress) {
        const promises = this.selectedUserSubjects.map(async (userSubject) => {
            new UserSubjectModel().user(userSubject.tempStudentId || '').put([{ subject: userSubject.tempSubjectId, progress }]);
        });
        await Promise.all(promises);
        this.handleStatusChanged();
        await this.onMounted();
    }
    async onBulkSortSummary() {
        // TODO: @STEFANO
        await this.onMounted();
    }
    async onBulkStatusChanged(status, isDefault) {
        if (isDefault) {
            this.isDisplayingBulkUpdateStatusFinishedRatingDialog = true;
            return;
        }
        const subjects = this.selectedUserSubjects.map((userSubject) => {
            return {
                subject: userSubject.subject,
                user: userSubject.status === UserSubjectStatusEnum.INACTIVE ? userSubject.student : userSubject.user,
            };
        });
        const payload = {
            status,
            subjects,
        };
        await new UserSubjectModel().bulkUpdate(payload).catch((error) => {
            ErrorHandler.network(error);
        });
        this.handleStatusChanged();
        this.selectedStatus = '';
    }
    onClickTotal(status, subjectId, subjectIndex) {
        if (!this.userSubjectGrid) {
            return;
        }
        const subject = this.subjectStatusTotals[subjectId];
        if (!subject) {
            return;
        }
        const total = subject[status];
        const itemsInColumnWithStatus = Object.values(this.userSubjectGrid).filter((userSubject) => userSubject.tempSubjectIndex === subjectIndex && userSubject.status === status);
        const selected = itemsInColumnWithStatus.filter((item) => item.tempSelected);
        const selectedCount = selected.length;
        // select
        if (total !== selectedCount) {
            const deselected = itemsInColumnWithStatus.filter((item) => !item.tempSelected);
            deselected.forEach((item) => {
                item.tempSelected = true;
            });
            return;
        }
        // deselect
        selected.forEach((item) => {
            item.tempSelected = false;
        });
    }
    onFiltersChanged() {
        this.emptySelected();
        this.fetchUserSubjects();
    }
    onOpenSubjectDialog(subject) {
        if (!subject || !subject.id) {
            return;
        }
        this.subjectDialogSubject = subject;
        this.isSubjectDialogOpen = true;
    }
    async onPriorityChange(state) {
        this.isLoading = true;
        await Promise.all(this.selectedUserSubjects.map(async (selectedUserSubject) => {
            if (!selectedUserSubject.tempStudentId || !selectedUserSubject.tempSubjectId) {
                return;
            }
            await this.updatePriority(selectedUserSubject.tempStudentId, selectedUserSubject.tempSubjectId, state);
        }));
        this.isLoading = false;
        this.handleStatusChanged();
    }
    async onUserSubjectProgressUpdated(progress, userSubject) {
        if (!userSubject) {
            return;
        }
        await new UserSubjectModel().user(userSubject.tempStudentId || '').put([{ subject: userSubject.tempSubjectId, progress }]);
    }
    async onUserSubjectSubjectUpdated() {
        await this.onMounted();
    }
    // #endregion
    // #region Class methods
    emptySelected() {
        this.selectedUserSubjects.forEach((selectedUserSubject) => {
            if (!selectedUserSubject) {
                return;
            }
            selectedUserSubject.tempSelected = false;
        });
    }
    async handleStatusChanged() {
        this.emptySelected();
        this.fetchUserSubjects();
        this.$emit('subjectsUpdated');
    }
    openTreatmentDialog(studentId) {
        this.selectedStudentId = studentId;
        this.isEditingTreatment = true;
    }
    sideScrollSummaryTable(element, direction) {
        // 262.5 is the width of a table column.
        const amountToScroll = 262.5 * 1;
        element.scrollBy({
            left: direction === 'left' ? -Math.abs(amountToScroll) : amountToScroll,
            behavior: 'smooth',
        });
    }
    onTreatmentSaved(studentId, treatments) {
        const index = this.students.findIndex((student) => student.id === studentId);
        if (index === -1) {
            return;
        }
        const student = this.students[index];
        student.treatment_labels = treatments;
        this.students.splice(index, 1, student);
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchUserSubjects() {
        // If there's a rejector (for the previous call)
        if (this.fetchUserSubjectsPromiseRejector) {
            // Reject the previous call
            this.fetchUserSubjectsPromiseRejector(null);
            // Clear the var
            this.fetchUserSubjectsPromiseRejector = null;
            // If there's a timeout (for the previous call)
            if (this.fetchUserSubjectsTimeout) {
                // Clear the previous timeout
                clearTimeout(this.fetchUserSubjectsTimeout);
                // Clear the var
                this.fetchUserSubjectsTimeout = null;
            }
        }
        // Start loading
        this.isLoading = true;
        this.hasUserSubjects = false;
        this.$nextTick(async () => {
            this.isLoading = true;
            this.hasUserSubjects = false;
            if (!this.canFetchUserSubjects) {
                this.isLoading = false;
                return;
            }
            try {
                // Create a promise
                const promise = new Promise(async (resolve, reject) => {
                    // Within this promise: Save the rejector
                    this.fetchUserSubjectsPromiseRejector = reject;
                    // Within this promise: Await the fetch call
                    const result = await doFetchUserSubjects(this.filters);
                    // Within the promise: Tell the promise it's resolved
                    resolve(result);
                });
                // Await the promise
                const { subjects, students, userSubjectGrid, subjectStatusTotals, hasUserSubjects, } = await promise;
                // If the promise above is rejected while we're awaiting, we don't get till this point, it will go into catch
                // And thus the previous slow  call of e.g. 4 sec won't override the data of the current call of e.g. 1 sec
                // In the future it would be better and easier to use AxiosSource.cancel() instead
                this.subjects = subjects;
                this.students = students;
                this.userSubjectGrid = userSubjectGrid;
                this.subjectStatusTotals = subjectStatusTotals;
                this.fetchUserSubjectsTimeout = setTimeout(() => {
                    this.hasUserSubjects = hasUserSubjects;
                    this.initialState = false;
                    this.isLoading = false;
                }, 500);
            }
            catch (error) {
                if (error === null) {
                    // If error === null: We ended up in catch because there's a new promise that rejected this one, this is not a real error
                    return;
                }
                // Else we have to do with a normal error
                this.subjects = [];
                this.students = [];
                this.userSubjectGrid = {};
                this.subjectStatusTotals = {};
                this.initialState = false;
                this.isLoading = false;
                ErrorHandler.network(error);
                // this.loadFailed = true;
            }
        });
    }
    async updatePriority(userId, subjectId, priority) {
        return await new UserSubjectModel().user(userId).putSubject([
            {
                subject: subjectId,
                has_priority: priority,
            },
        ]);
    }
    // #endregion
    // #region Getters & Setters
    get dialogOptionsResetStudentStatuses() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.reset', { item: this.$t('dialogOptions.item.helpAndFinished') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.reset').toString(),
                    action: () => {
                        const subjects = [];
                        const users = [];
                        this.selectedUserSubjects.forEach((selectedUserSubject) => {
                            if (selectedUserSubject.tempSubjectId) {
                                subjects.push(selectedUserSubject.tempSubjectId);
                            }
                            if (selectedUserSubject.tempStudentId) {
                                users.push(selectedUserSubject.tempStudentId);
                            }
                        });
                        const payload = {
                            users,
                            subjects,
                        };
                        new UserSubjectModel()
                            .bulkUpdateClearStudentStatuses(payload)
                            .then((response) => {
                            this.handleStatusChanged();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    get miniState() {
        return this.$store.state.miniNav;
    }
    get selectedUserSubjects() {
        if (!this.userSubjectGrid) {
            return [];
        }
        return Object.values(this.userSubjectGrid).filter((userSubject) => userSubject && userSubject.tempSelected);
    }
    get snackbarActions() {
        const areSelectedSubjectsBusy = this.selectedUserSubjects.every((subject) => subject.status === UserSubjectStatusEnum.HIGHLIGHTED);
        const containsInactiveSubject = this.selectedUserSubjects.some((subject) => subject.status === UserSubjectStatusEnum.INACTIVE);
        const areSelectedUserSubjectsInSameSubject = this.selectedUserSubjects.every((subject) => subject.tempSubjectId === this.selectedUserSubjects[0].tempSubjectId);
        return [
            {
                icon: 'do_not_disturb_on',
                click: () => {
                    this.emptySelected();
                },
                label: this.$t('snackbar.actions.deselect').toString(),
            },
            ...(areSelectedSubjectsBusy
                ? [
                    {
                        icon: 'edit',
                        click: () => {
                            this.isDisplayingProgressDialog = true;
                        },
                        label: 'Voortgang',
                    },
                ]
                : []),
            ...(areSelectedUserSubjectsInSameSubject && !containsInactiveSubject
                ? [
                    {
                        icon: 'list',
                        click: () => {
                            this.isDisplayingBulkUpdateDescriptionDialog = true;
                        },
                        label: this.$t('snackbar.actions.roadmap').toString(),
                    },
                ]
                : []),
            {
                icon: 'nearby_error',
                click: () => {
                    this.onPriorityChange(true);
                },
                label: 'Prio geven',
            },
            {
                icon: 'not_interested',
                click: () => {
                    this.onPriorityChange(false);
                },
                label: 'Prio verwijderen',
            },
            ...(this.exclude
                ? []
                : [
                    {
                        icon: 'question_answer',
                        click: () => {
                            this.isDisplayingIdpNotesDialog = true;
                        },
                        label: this.$t('snackbar.actions.chat').toString(),
                    },
                    {
                        icon: 'error_outline',
                        click: () => {
                            this.$store.dispatch('openDialog', this.dialogOptionsResetStudentStatuses);
                        },
                        label: this.$t('snackbar.actions.reset_statuses').toString(),
                    },
                ]),
        ];
    }
    get subjectIdForTreatementDialog() {
        if (this.$route.params.subjectid) {
            return this.$route.params.subjectid;
        }
        return this.$route.params.id;
    }
    get userSubjectRooms() {
        return uniq(this.selectedUserSubjects
            .filter((selectedUserSubject) => selectedUserSubject.status === 'highlighted' && selectedUserSubject.room)
            .map((selectedUserSubject) => selectedUserSubject.room));
    }
    get canFetchUserSubjects() {
        if (this.filters.groups && this.filters.groups.length) {
            return true;
        }
        if (this.filters.event) {
            return true;
        }
        if (this.filters.user) {
            return true;
        }
        if (this.filters.users && this.filters.users.length) {
            return true;
        }
        const hasLevelsFilter = this.filters.levels && this.filters.levels.length;
        const hasPeriodsFilter = this.filters.periods && this.filters.periods.length;
        return !!((hasLevelsFilter || hasPeriodsFilter));
    }
    get user() {
        return this.$store.state.Auth;
    }
    get groupNotesDialogGroupId() {
        if (this.preselectedGroup) {
            return this.preselectedGroup.id;
        }
        return this.filters.groups ? this.filters.groups[0] : '';
    }
    // #endregion
    // #region @Watchers
    filtersChanged(newFilters, oldFilters) {
        this.debounceFetchUserSubjects();
    }
};
__decorate([
    Prop({ default: () => null }),
    __metadata("design:type", Object)
], SubjectOverviewNew.prototype, "event", void 0);
__decorate([
    Prop({ default: () => ({}) }),
    __metadata("design:type", Object)
], SubjectOverviewNew.prototype, "filters", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], SubjectOverviewNew.prototype, "labels", void 0);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SubjectOverviewNew.prototype, "filtersChanged", null);
SubjectOverviewNew = __decorate([
    Component({
        components: {
            ProgressDialog,
            AlertCard,
            PageHeader,
            BulkUpdateStatusFinishedRatingDialog,
            UserSubjectMessageForm,
            BulkUpdateDescriptionDialog,
            LoadFailed,
            LoaderCard,
            SelectFilter,
            TreatmentDialog,
            StatusCard,
            EditSubjectDialog,
            DescriptionColumn,
            SubjectDialog,
            ScoolSnackbar,
            DownloadOverviewDialog,
            // New components
            SubjectGoalIcons,
            SubjectUser,
            SubjectHeader,
            UserSubject,
            SubjectGroupSelect,
            GroupNotesDialog,
        },
    })
], SubjectOverviewNew);
export default SubjectOverviewNew;
// #endregion
// #region Constants
class UserSubjectModelForSubjectOverview extends UserSubjectModel {
    constructor() {
        super(...arguments);
        this.tempUserSubjectId = '';
        this.tempSelected = false;
        this.tempSubjectIndex = 0;
        this.tempStudentIndex = 0;
        this.tempStudentId = undefined;
        this.tempStudent = undefined;
        this.tempSubjectId = undefined;
        this.tempHasPriority = false;
    }
}
const doFetchUserSubjects = async (origFilters) => {
    let filters = omitBy(origFilters, (value) => {
        return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
    });
    if (filters.event) {
        filters = {
            event: filters.event,
        };
    }
    const userSubjectSummary = await new UserSubjectSummary()
        .include(['parent', 'level', 'period'])
        .filter(filters)
        .load();
    const subjects = userSubjectSummary.data.meta.subjects.map((subject) => new Subject(subject));
    const sortedSubjects = sortSubjects(subjects);
    const students = sortBy(userSubjectSummary.data.meta.users.map((student) => new Student(student)), 'name');
    const userSubjectGrid = morphUserSubjectSummary(subjects, students, userSubjectSummary.data.data);
    const subjectStatusTotals = getStatusTotals(userSubjectSummary.data.data);
    let hasUserSubjects = true;
    if (userSubjectSummary.data.data && userSubjectSummary.data.data.length) {
        hasUserSubjects = true;
    }
    return {
        subjects: sortedSubjects,
        students,
        userSubjectGrid,
        subjectStatusTotals,
        hasUserSubjects,
    };
};
const morphUserSubjectSummary = (subjects, students, userSubjects) => {
    const userSubjectGrid = {};
    subjects.forEach((subject, subjectIndex) => {
        students.forEach((student, studentIndex) => {
            let userSubject = userSubjects.find((currentUserSubject) => {
                return currentUserSubject.subject === subject.id &&
                    currentUserSubject.user === student.id;
            });
            // When no UserSubject was found create an empty one
            if (!userSubject) {
                userSubject = new UserSubjectModelForSubjectOverview({ student: student.id, subject: subject.id, status: 'inactive' });
            }
            userSubject.tempUserSubjectId = userSubject.id || '';
            userSubject.tempSelected = false;
            userSubject.tempSubjectIndex = subjectIndex;
            userSubject.tempStudentIndex = studentIndex;
            userSubject.tempStudentId = student.id;
            userSubject.tempStudent = student;
            userSubject.tempSubjectId = subject.id;
            userSubject.tempHasPriority = !!userSubject.has_priority;
            userSubjectGrid[`${subjectIndex},${studentIndex}`] = userSubject;
        });
    });
    return userSubjectGrid;
};
const sortSubjects = (subjects) => {
    // sort like php's natcasesort, e.g. 1.1, 1.2, 1.10
    // https://stackoverflow.com/a/38641281/16340209
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    // sort by name
    subjects.sort((a, b) => collator.compare(a.name || '', b.name || ''));
    // sort by period
    subjects.sort((a, b) => collator.compare(a.period && a.period.value ? a.period.value : '', b.period && b.period.value ? b.period.value : ''));
    // sort by level
    subjects.sort((a, b) => collator.compare(a.level && a.level.sequence ? a.level.sequence : '', b.level && b.level.sequence ? b.level.sequence : ''));
    return subjects;
};
const getStatusTotals = (userSubjects) => {
    const groupedBySubject = groupBy(userSubjects, 'subject');
    const subjectStatusTotals = {};
    Object.keys(groupedBySubject).forEach((subjectId) => {
        const subjects = groupedBySubject[subjectId];
        const groupedByStatus = groupBy(subjects, 'status');
        const statuses = ['inactive', 'highlighted', 'busy', 'old', 'closed', 'finished'];
        const statusTotals = {};
        statuses.forEach((status) => {
            statusTotals[status] = groupedByStatus[status] ? groupedByStatus[status].length : 0;
        });
        subjectStatusTotals[subjectId] = statusTotals;
    });
    return subjectStatusTotals;
};
// #endregion
